export interface IHelpersItem {
  id: number;
  link: string;
  icon: string;
  title: string;
  description: string;
}

export const items: IHelpersItem[] = [
  {
    id: 1,
    link: 'https://academia360.eduzz.com',
    icon: 'flag',
    title: 'Primeiros Passos',
    description: 'Estou começando na Eduzz'
  },
  {
    id: 2,
    link: 'https://ajuda.eduzz.com/?article-category=tutorial',
    icon: 'book',
    title: 'Treinamentos / Tutoriais',
    description: 'Aprenda mais sobre o negócio e a Eduzz'
  },
  {
    id: 3,
    link: 'https://ajuda.eduzz.com',
    icon: 'help',
    title: 'F.A.Q',
    description: 'Respostas das perguntas mais frequentes'
  },
  {
    id: 4,
    link: 'https://blog.eduzz.com/',
    icon: 'language',
    title: 'Blog',
    description: 'Notícias, comunicados e mais'
  }
];
